<!-- quotation-reject-popup -->
<div class="common-popup-container comment-open-view-wrapper" *ngIf="true">
    <img src="assets/images/new-set/thin-cancel.svg" class="close-icon" alt="">

    <!-- <h3 class="title mb-4">Quotation Rejected</h3> -->
    <h3 class="title mb-4">Quotation : #839201834</h3>

    <div class="d-flex align-items-center" *ngIf="true">
        <span class="highlight-badge new-badge-container">
            <img src="assets/images/product_item_icon.jpg" class="new-badge-icon" alt=""> #52617171
        </span>
        <span class="highlight-badge new-badge-container ml-1">
            <img src="assets/images/product_item_icon.jpg" class="new-badge-icon" alt=""> #52617171
        </span>
    </div>

    <div class="d-flex align-items-center" *ngIf="false">
        <img src="assets/images/product_item_icon.jpg" alt="">
        <span class="title mb-0 ml-1">#52617171</span>
    </div>

    <div class="my-input-group mt-3">
        <label for="">Rejected Reason</label>
        <textarea name="" id=""
            placeholder="This comment provided by the customer explains the reason for rejection and cannot be modified once submitted."
            style="resize: none;"></textarea>
    </div>
</div>